module.exports = __webpack_public_path__ + "static/media/vase.70e5a068.png";